import { viewStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsView";
import { css } from "styled-components";

viewStyles.rightColumnGridItem = { width: [0, 0, 0, 4, 4] };
viewStyles.rightColumnGridItemHidden = {
    below: "lg",
    css: css`
        width: 100%;
    `,
};

viewStyles.middleGridItem = { width: [12, 12, 12, 0, 0] };
viewStyles.middleGridItemHidden = {
    above: "md",
    css: css`
        width: 100%;
    `,
};
